import timeData from './timeData'

export default{
    state: {
        timezone: timeData
    },
    getters: {
        timeZone:(state) => state.timezone,
    }
}